import {ReactElement} from 'react';

import {SpriteSVG} from '../assets/img/svg';

interface VectorIconProps {
  iconName: string;
  className?: string;
}

export default function VectorIcon({
  iconName,
  className,
}: VectorIconProps): ReactElement {
  return (
    <svg className={className}>
      <use xlinkHref={`${SpriteSVG}#${iconName}`} />
    </svg>
  );
}
